import { ContactForm } from './Form';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { AstroLocale } from '@/schemas/components/shared/i18n';
import type { TfValue } from '@/types/form';

const queryClient = new QueryClient();

export interface ContactFormProps {
  conversionType?: string;
  dataSource: string;
  formType: 'standard' | 'compact';
  language: AstroLocale;
  submitText?: string;
  tfValue?: TfValue;
  thankYouPage: string;
  defaultHowCanWeHelp?: string;
}

export const FormProvider = ({ ...props }: ContactFormProps) => (
  <QueryClientProvider client={queryClient}>
    <ContactForm {...props} />
  </QueryClientProvider>
);
